import {FieldErrors} from "react-hook-form/dist/types/errors";
import React, {ReactNode} from "react";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {Path, useFormContext, UseFormSetError} from "react-hook-form";
import {SubmitHandler} from "react-hook-form/dist/types/form";
import {FieldError} from "../../technical/rest/errorHandling";
import {TFunction} from "i18next";

/**
 * A handler method to be used as second parameter for RHF handleSubmit method. Will print out validation errors that prevent submitting.
 */
export function onFormSubmitInvalid(errors: FieldErrors, event?: React.BaseSyntheticEvent) {
  console.warn('Submit not possible: ' + JSON.stringify(errors));
}

export type RhfFormProps<TFieldValues extends FieldValues = FieldValues> = {

  /**
   * Your own submit handler. E.g. the place to call the backend
   */
  onSubmit: SubmitHandler<TFieldValues>,

  id: string | undefined,

  children?: ReactNode,
}

/**
 * A wrapper around the HTML form tag that forces definition of onInvalid handler
 */
export function RhfForm<TFieldValues extends FieldValues = FieldValues>(props: RhfFormProps<TFieldValues>) {
  const {handleSubmit} = useFormContext<TFieldValues>();

  return (
    <form id={props.id} onSubmit={handleSubmit(props.onSubmit, onFormSubmitInvalid)}>
      {props.children}
    </form>
  )
}

export function handleFormError<TFieldValues>(error: any, setError: UseFormSetError<TFieldValues>, t: TFunction) {
  // console.info('handleFormError: ', error);
  if (error?.data?.fieldErrors) {
    error.data.fieldErrors.forEach((fieldError: FieldError) =>
      setError(
        fieldError.field as Path<TFieldValues>,
        {message: t("FormErrors." + fieldError.defaultMessage,
            {field: fieldError.objectName ? t(firstLetterToUppercase(fieldError.objectName) + "." + fieldError.field) : fieldError.field})}
      ));
  } else {
    throw error;
  }
}

export function firstLetterToUppercase(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
